<div class="row noMargin" style="display:flex">
 <div class="col-md-10 footerContentCls">
  Copyright <i class="fa fa-copyright"></i> {{currentYear}} Deloitte Development LLC. All rights reserved.
</div>
<div class=" col-md-1 footerContentPTCls">
  <a routerLink="privacy" >Privacy Policy</a>
</div>
<div class="col-md-1 footerContentPTCls clsCursorPointer">
  <a  routerLink="terms">Terms of Use</a>
</div>

<div class="col-md-1 footerContentPTCls clsCursorPointer">
  <a target="_blank" href="https://cookienotice.deloitte.com">Cookies</a>
</div>

<div class="col-md-2 footerContentPTCls clsCursorPointer">
  <a class="optanon-toggle-display">Cookie Settings</a>
</div>
 